var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    fill: "#f78786",
    enableBackground: "new 0 0 512.051 512.051",
    height: 512,
    viewBox: "0 0 512.051 512.051",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_15_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exclamation_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m336.051 432.026c0 44.197-35.829 80.026-80.026 80.026s-80.025-35.829-80.025-80.026 35.829-80.026 80.026-80.026c44.185.028 79.997 35.84 80.025 80.026zm-150.733-406.836 13.568 272.026c.68 12.768 11.227 22.775 24.013 22.784h66.56c12.786-.009 23.333-10.016 24.013-22.784l13.312-272.026c.679-13.216-9.485-24.48-22.701-25.159-.42-.022-.84-.032-1.26-.032h-93.543c-13.234-.017-23.976 10.696-23.993 23.93-.001.421.01.842.031 1.261z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/Note.9b14ec0a7cb1e21e3f7124fe6045815e.svg";
export { ForwardRef as ReactComponent };